import AppBar from '@mui/material/AppBar'
import { Button, Toolbar, Typography, Box, Chip } from '@mui/material';
import { getCount } from '../services/VisitorCount';
import { useEffect, useState } from 'react';

export default function Navbar() {

    const [count, setCount] = useState("...");

    useEffect(() => {
        async function fetchData() {
            try {
                const result = await getCount();
                setCount(result);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, []);

    const handleScrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return(
        <AppBar position='fixed' sx={{ bgcolor: '#0a0a0a', boxShadow: '0 1px 0 rgba(255,255,255,0.08)' }}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Typography
                    variant='h6'
                    sx={{ fontWeight: 700, letterSpacing: '0.05em', cursor: 'pointer' }}
                    onClick={() => handleScrollToSection('about')}
                >
                    Quinn Peterson
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
                    <Button color='inherit' size='small' onClick={() => handleScrollToSection('about')}>About</Button>
                    <Button color='inherit' size='small' onClick={() => handleScrollToSection('skills')}>Skills</Button>
                    <Button color='inherit' size='small' onClick={() => handleScrollToSection('projects')}>Projects</Button>
                    <Button color='inherit' size='small' onClick={() => handleScrollToSection('contact')}>Contact</Button>
                    <Chip
                        label={`${count} visitors`}
                        size='small'
                        sx={{
                            ml: 1,
                            bgcolor: 'rgba(0,127,255,0.2)',
                            color: '#60aaff',
                            border: '1px solid rgba(0,127,255,0.4)',
                            fontSize: '0.7rem',
                            display: { xs: 'none', sm: 'flex' }
                        }}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
